import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import {
  apiSpec,
  AuthEvmSignaturePathSchema,
  AuthEvmSignaturePayloadSchema,
  type AuthEvmSignatureResponseSchema,
} from '@rhinofi/authentication-api-spec'
import { Effect } from 'effect'
import { HttpApiClient } from 'effect/http-api'
import { envConfig } from '../../env/envConfig'
import { runApiRequest } from '../../services/api/runApiRequest'

const apiClient = HttpApiClient.make(apiSpec, { baseUrl: `${envConfig.tradingApi}/authentication` })

export const authApi = createApi({
  reducerPath: 'authApi',
  baseQuery: fetchBaseQuery({}),
  endpoints: (builder) => ({
    genEVMSignature: builder.mutation<
      AuthEvmSignatureResponseSchema,
      { ethAddress: string; signature: string; createdAt: Date }
    >({
      queryFn: ({ ethAddress, signature, createdAt }) =>
        runApiRequest(
          Effect.gen(function* () {
            const client = yield* apiClient
            return yield* client.auth.authEvmSignature({
              params: yield* AuthEvmSignaturePathSchema.makeEffect({ ethAddress }),
              payload: yield* AuthEvmSignaturePayloadSchema.makeEffect({ version: 3, signature, createdAt }),
            })
          }),
        ),
    }),
  }),
})

export const { useGenEVMSignatureMutation } = authApi
